import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  loading: false,
  loaded: false,
  data: [],
  error: {},
})

const { Types, Creators } = createActions({
  getOrderLocations: ['startFrom', 'endAt'],
  setOrderLocations: ['orders'],
  setOrderLocationsLoading: ['val'],
})

export const setOrderLocationsReducer = (state, { orders }) => {
  return state
    .set('loading', false)
    .set('loaded', true)
    .set('data', orders)
}
export const setOrderLocationsLoadingReducer = (state, { val }) =>
  state.set('loading', val).set('loaded', !val)

export const locationReportReducer = createReducer(INITIAL_STATE, {
  [Types.SET_ORDER_LOCATIONS]: setOrderLocationsReducer,
  [Types.SET_ORDER_LOCATIONS_LOADING]: setOrderLocationsLoadingReducer,
})

export const LocationReportTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/locationReportReducer.js